import { API } from '~/constants';
import { useEffect, useState } from 'react';
import { post } from '~/utils';

interface OpenPermission {
    has_data_api: boolean;
    has_api_key: boolean;
    has_plugin_store: boolean;
    has_official_plugin_store: boolean;
    has_enterprise_plugin_store: boolean;
    has_data_source_store: boolean;
    has_official_data_source_store: boolean;
    has_custom_runtime: boolean;
    is_mcp_service_enabled?: boolean;
}

/** 检查开放平台相关可用性 */
const useOpenPermission = () => {
    const [openPermission, setOpenPermission] = useState<OpenPermission>();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        post(API.open.get_permission)
            .then((res) => {
                setOpenPermission(res.data);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return { openPermission, loading };
};

export default useOpenPermission;
